import React, { useState, useRef } from "react"
import { Box, Flex, Container, Heading } from "theme-ui"
import GatbsyNavLink from "./GatsbyNavLink"
import { Pagination, AccordionNav } from "./sidenav"

import Head from "./head"
import Header from "./header"
import Footer from "./footer"
import Nav from "./nav"
import CUSTOM_NAVS from "../constants/customNavs"
import RightBanner from "./RightBanner"

import { getCustomNavKey, isArticlePage } from "../util"

import Reactions from "./reactions"
import ArticleFooter from "./Articles/ArticleFooter"

const Navigation = (props) => {
  const navKey = getCustomNavKey(props)

  if (navKey) {
    return React.createElement(CUSTOM_NAVS[navKey], props)
  }

  return <Nav {...props} />
}

const Content = (props) => {
  const title = props.title || props.pageContext?.frontmatter?.title

  const subtitle = props.subtitle || props.pageContext?.frontmatter?.subtitle

  return (
    <>
      <Head {...props} />
      <Heading
        sx={{
          mx: "auto",
          width: "100%",
          maxWidth: "34ch",
          textAlign: "center",
          mb: subtitle ? 0 : "3rem",
          mt: "6rem",
          fontSize: "2.5em",
        }}
        as="h1"
      >
        {title}
      </Heading>
      {subtitle ? (
        <Heading
          sx={{
            mx: "auto",
            width: "100%",
            maxWidth: "34ch",
            textAlign: "center",
            mb: "3rem",
            fontSize: "1.5em",
          }}
          as="h2"
        >
          {subtitle}
        </Heading>
      ) : null}
      <Container as="main" id="content">
        {props.children}

        {props.isArticle ? <ArticleFooter {...props} /> : null}
      </Container>
    </>
  )
}

export default (props) => {
  const fullwidth = props.fullwidth
  const isArticle =
    props.pageContext.frontmatter !== undefined && isArticlePage(props)
  const [menuOpen, setMenuOpen] = useState(props.authorized)
  const nav = useRef(null)

  return (
    <Box
      sx={{
        variant: "styles.root",
      }}
    >
      <Header
        menuOpen={menuOpen}
        setMenuOpen={setMenuOpen}
        nav={nav}
        siteTitle={props.siteTitle}
        courseFirstLesson={props.courseFirstLesson}
      />

      <RightBanner {...props} />

      <Flex sx={{ pt: "64px" }}>
        <Box
          sx={{
            display: [
              menuOpen ? "fixed" : "none",
              !fullwidth ? "block" : menuOpen ? "block" : "none",
            ],
            width: [256, 256, 320],
            overflowY: "auto",
            height: "100%",
            maxHeight: "100%",
            px: 3,
            pb: 4,
            "li > div": {
              py: 1,
            },
            "li > a": {
              pl: [1, 2],
              pb: 1,
            },
          }}
          onClick={(e) => {
            setMenuOpen(false)
          }}
          onBlur={(e) => {
            setMenuOpen(false)
          }}
          onFocus={(e) => {
            setMenuOpen(true)
          }}
        >
          <Navigation
            open={!fullwidth && menuOpen}
            role="navigation"
            pathname={props.location.pathname}
            components={{
              wrapper: AccordionNav,
              a: GatbsyNavLink,
            }}
          />
        </Box>
        <Container
          sx={{
            minHeight: "calc(100vh - 64px)",
            px: [3, 4],
            pb: 5,
            maxWidth: fullwidth ? "100%" : "container",
          }}
        >
          <Content
            {...props}
            fullwidth={fullwidth}
            menuOpen={menuOpen}
            setMenuOpen={setMenuOpen}
            isArticle={isArticle}
          />

          {!props.fullwidth && <Reactions page={props.uri} />}
          <Navigation
            pathname={props.location.pathname}
            components={{
              wrapper: Pagination,
            }}
          />
        </Container>
      </Flex>

      <Footer />
    </Box>
  )
}
